import { useQuery } from "@tanstack/react-query";
import { fetchAPI, TASKS_SERVICE_URL } from "../API/tasks.service.helper";
import { INTERVAL } from "../../constants/clientTime";

export const LAST_REFILLED_QUERY_KEY = "locationLastRefilled";
export const useLocationLastRefilled = (
  isRefillLocation: boolean,
  articleNo: string,
  refillLocation: string
) => {
  const canFetch = Boolean(isRefillLocation && articleNo && refillLocation);

  return useQuery({
    queryKey: [LAST_REFILLED_QUERY_KEY, articleNo, refillLocation],
    queryFn: async () => {
      if (!canFetch) {
        return null;
      }
      const params = new URLSearchParams({ articleNo });
      if (refillLocation) {
        params.append("refillLocation", refillLocation);
      }
      const callUrl = `${TASKS_SERVICE_URL}/v1/tasks/task_last_refilled?${params.toString()}`;
      const response = await fetchAPI("GET", callUrl);
      return response ? response.result : null;
    },
    enabled: canFetch,
    staleTime: 1 * INTERVAL.MINUTE,
  });
};
